// extracted by mini-css-extract-plugin
module.exports = {"trustPilot":"_2BLLq-8z5WoOBxD_","container":"_3qiRc0udaZz73hD8"};